import type { SVGProps } from "react";
export function Eye(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m1.85947 8.00004c.83076 2.42456 3.1302 4.16666 5.83525 4.16666 2.70508 0 5.00448-1.7421 5.83528-4.16666-.8308-2.42459-3.1302-4.16667-5.83528-4.16667-2.70505 0-5.00448 1.74206-5.83525 4.16667zm-1.003243-.14987c.913093-2.90711 3.628763-5.0168 6.838493-5.0168 3.20978 0 5.92538 2.10972 6.83848 5.01687.0307.09753.0307.20213 0 .29967-.9131 2.90709-3.6287 5.01679-6.83848 5.01679-3.20973 0-5.92542-2.1097-6.838493-5.01686-.030633-.09753-.030633-.20213 0-.29967zm6.838163-1.35013c-.8284 0-1.49997.6716-1.49997 1.5s.67157 1.5 1.49997 1.5c.82846 0 1.5-.6716 1.5-1.5s-.67154-1.5-1.5-1.5zm-2.49997 1.5c0-1.38071 1.11929-2.5 2.49997-2.5 1.38073 0 2.50001 1.11929 2.50001 2.5 0 1.38073-1.11928 2.49996-2.50001 2.49996-1.38068 0-2.49997-1.11923-2.49997-2.49996z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
